// ABOUTME: Hook for generating subscription configurations.
// ABOUTME: Eliminates code duplication by creating unified subscription config objects.

import { useMemo } from "react"
import { ProductType } from "@/graphql/main/gql/graphql"
import type { ProductListBuyFragment } from "@/graphql/main/gql/graphql"
import type { SubscriptionConfig } from "@/features/settings/components/Payment/types/subscription"
import { useSubscriptions } from "./useSubscriptions"
import { useUserSubscriptionStatus } from "./useUserSubscriptionStatus"

export const useSubscriptionConfigs = () => {
  const { products, canceledSubscriptions } = useSubscriptions()
  const { isPro, proDate, coachDate, isCoachPaid } = useUserSubscriptionStatus()

  const subscriptionConfigs: SubscriptionConfig[] = useMemo(() => {
    const configs: SubscriptionConfig[] = []

    // PRO subscription configuration
    if (products.pro) {
      configs.push({
        productType: ProductType.SystemPro,
        isPaid: isPro,
        datePaid: proDate ?? undefined,
        product: products.pro as ProductListBuyFragment,
        productVariants: products.proAll as ProductListBuyFragment[],
        canceledSubscriptions: canceledSubscriptions.pro,
        scheduledSubscription: canceledSubscriptions.scheduled.pro,
      })
    }

    // Coach subscription configuration
    if (products.coach) {
      configs.push({
        productType: ProductType.SystemCoach,
        isPaid: isCoachPaid,
        datePaid: coachDate ?? undefined,
        product: products.coach as ProductListBuyFragment,
        productVariants: products.coachAll as ProductListBuyFragment[],
        canceledSubscriptions: canceledSubscriptions.coach,
        scheduledSubscription: canceledSubscriptions.scheduled.coach,
      })
    }

    return configs
  }, [
    products.pro,
    products.proAll,
    products.coach,
    products.coachAll,
    isPro,
    proDate,
    coachDate,
    isCoachPaid,
    canceledSubscriptions.pro,
    canceledSubscriptions.coach,
    canceledSubscriptions.scheduled.pro,
    canceledSubscriptions.scheduled.coach,
  ])

  return subscriptionConfigs
}
